import React, { Fragment } from 'react';
import Button from 'b2b-ui-components-lib/lib/components/button';
import './processComponent.scss';
import Tooltip from '../../../../../../../common/components/tooltip-component/tooltip-component';
import { FEASIBILITY_LOCATION_STATUS, TOOLTIP_MESSAGE } from '../../../../constants/multiSite-constants';

const processComponent = ({
  showProcessConfigSection = false,
  processIdLabel = '',
  processId = '',
  processSiteProcessed = '',
  processSiteLabel = '',
  processBtnDisabled = false,
  processBtnName = 'Edit with Excel',
  onProcessBtnClick = () => {},
  icon = '',
  toolTipMessage = '',
  sitesLoading = false,
  showEditExcelButtonLoader = false,
  isAOI = false,
  hasValidStatusMap = false,
  addressResolutionAOIComponent = false
}) => {
  return (
    <ul className="process_items">
      {processIdLabel && processId && (
        <li>
          <div className="servics_title">
            {sitesLoading ? (
              <span className="text_shimmer" />
            ) : (
              <Fragment>
                <span className="ttl_lable">{processIdLabel}</span>
                <span className="service_value pl-5">{processId}</span>
              </Fragment>
            )}
          </div>
        </li>
      )}
      <li>
        <div className="servics_title">
          {sitesLoading ? (
            <span className="text_shimmer" />
          ) : (
            <Fragment>
              <span className="ttl_lable">{processSiteLabel}</span>:
              <span className="total_count" style={{ marginLeft: '5px' }}>
                {processSiteProcessed}
              </span>
            </Fragment>
          )}
        </div>
      </li>
      {isAOI && !!hasValidStatusMap && <li></li>}
      {!isAOI && (
        <li>
          <Tooltip message={toolTipMessage}>
            <Button onClick={onProcessBtnClick} disabled={processBtnDisabled || showEditExcelButtonLoader}>
              {processBtnName}
              {processBtnDisabled && !showEditExcelButtonLoader && <span className="loading_icon"></span>}
            </Button>
          </Tooltip>
        </li>
      )}
      {addressResolutionAOIComponent && (
        <li>
          <Tooltip message={toolTipMessage}>
            <Button onClick={onProcessBtnClick} disabled={processBtnDisabled || showEditExcelButtonLoader}>
              {processBtnName}
              {processBtnDisabled && !showEditExcelButtonLoader && <span className="loading_icon"></span>}
            </Button>
          </Tooltip>
        </li>
      )}
      {showProcessConfigSection && (
        <Fragment>
          <li>
            <span className="btn_text">View Available Configuration</span>
          </li>
          <li>
            <span className="btn_text">Email Pricing Proposal</span>
          </li>
          <li>
            <span className="btn_text" disabled>
              Need Assistance
            </span>
          </li>
        </Fragment>
      )}
    </ul>
  );
};

export default processComponent;
